import { createRequestConstantNames } from 'store/util/createConstants';
import cc from 'store/util/createReduxConstant';

export const [
  GET_COMPANY_FROM_MENA,
  GET_COMPANY_FROM_MENA_SUCCESS,
  GET_COMPANY_FROM_MENA_FAIL,
] = createRequestConstantNames(cc('GET_COMPANY_FROM_MENA'));
